import {
    FETCHED_STATIONS,
    SELECTED_AREA,
    SELECTED_ZONE,
    SELECTED_NAV_STATION, AREAS_FETCHED, ZONES_FETCHED,
    FILTERS_FETCHED,
    FILTER_CATEGORIES
} from "../types";
import _ from "lodash";
import axios from "axios/index";
import {tokenHeader} from "../../utils/headers";
import urls from "../../utils/urls";
import {ajaxHandler} from "../../utils/errors";


export function fetchAreas(areas) {
    return (dispatch) => {
        let keys = Object.keys(areas);
        let formattedAreas = [];
        for (let i in keys) {
            formattedAreas.push({
                id: areas[keys[i]].id,
                name: areas[keys[i]].name
            });
        }
        dispatch({type: AREAS_FETCHED, payload: formattedAreas})
    }

}

export function fetchZones(zones, area_id) {
    return (dispatch) => {
        let keys = Object.keys(zones);
        let formattedZones= [];
        for (let i in keys) {
            formattedZones.push({
                id: zones[keys[i]].id,
                name: zones[keys[i]].name,
                area: zones[keys[i]].area
            });
        }
        let areaZones = _.filter(formattedZones, (zone) => {
            return zone.area === area_id
        });
        dispatch({type: ZONES_FETCHED, payload: areaZones})
    }

}

export function fetchStations(all_stations, zone_id) {
    return (dispatch) => {
        let stations = all_stations;
        let keys = Object.keys(stations);
        let formattedStations= [];
        for (let i in keys) {
            formattedStations.push({
                id: stations[keys[i]].global_code,
                name: `${stations[keys[i]].global_code} - ${stations[keys[i]].company.name} - ${stations[keys[i]].city}`,
                zone: stations[keys[i]].zone
            });
        }
        let zonesStations = _.filter(formattedStations, (station) => {
            return station.zone === zone_id
        });
        dispatch({type: FETCHED_STATIONS, payload: zonesStations})
    }
}

export function selectArea(id) {
    return {
        type: SELECTED_AREA,
        payload: id
    };
}

export function selectZone(id) {
    return {
        type: SELECTED_ZONE,
        payload: id
    };
}

export function selectStation(id) {
    return {
        type: SELECTED_NAV_STATION,
        payload: id
    };
}

export function fetchFilters() {
    return (dispatch) => {
        const filters_url = `${urls.API_ROOT}/api/v1/filters/quarters/`;
        axios
            .get(filters_url, tokenHeader())
            .then((response) => dispatch(filtersFetched(response.data)))
            .catch(ajaxHandler);
    }
}

export function filtersFetched(filters) {
    let formattedFilters = [];

    if(filters.length>0){
        filters.forEach((filter, index) => {
            formattedFilters.push({label:`${filter.year} - ${filter.quarter}`, value:index, year:filter.year, quarter:filter.quarter});
        });
    }


    return {
        type: FILTERS_FETCHED,
        payload: formattedFilters
    };
}

export function filterCategories(filteredValue){
    return {
        type: FILTER_CATEGORIES,
        payload: filteredValue
    };
}


// WEBPACK FOOTER //
// ./src/actions/navigation_actions/index.js